import { Eye, EyeOff } from "lucide-react";
import React, { useState } from "react";

export default function PasswordInput(props) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="input__outer">
      {props.label && (
        <label htmlFor={props.label.replace(/\s/g, "")} className="!mb-1">
          {props.label}{" "}
          {props.isRequired ? <span className="text-red-500">*</span> : ""}
        </label>
      )}
      <div
        className={
          "input " +
          ((props.error && props.value === "") ||
          (props.page != "loginpage" && props.error && props.value.length < 8)
            ? "error"
            : "")
        }
      >
        <input
          onChange={props.onChange}
          value={props.value}
          // type={props.type}
          type={showPassword ? "text" : props.type}
          placeholder={props.placeholder}
          className="!rounded-lg !border !border-gray-200"
        />

        <div
          className="input__icon !bg-transparent !top-9 !right-3"
          onClick={togglePasswordVisibility}
        >
          {showPassword ? <Eye size={20} color="#9CA3AF" />: <EyeOff size={20} color="#9CA3AF" />}
        </div>
      </div>
      {((props.error && props.value === "") ||
        (props.error && props.value.length < 8)) && (
        <div className="input__error">{props.errorText}</div>
      )}
    </div>
  );
}
